import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'dv',
    fullName: 'Divehi',
    nativeName: 'Divehi',
    direction: 'rtl'
};

const translations: LocaleData = {
    title: "އާގްވޮއިޑް އެވެ",
    landing_title: "އަޖައިބު ކުރުވަނިވި ކަމެއް އަންނަނީ",
    landing_subtitle: "އާގްވޮއިޑް އަކީ އެޕް އަދި ގޭމް ޑިވެލޮޕްމަންޓް ސްޓޫޑިއޯއެކެވެ. އިންތިޒާރު ކުރައްވާ، ވަރަށް އަވަހަށް އާ ކަންތައްތަކެއް އަންނަނީ!",
    select_language: "ބަސް ހޮވާށެވެ",
    search_placeholder: "ބަސްތައް ހޯދުން...",
    terms_title: "ޚިދުމަތުގެ ޝަރުތުތައް",
    policy_title: "ޕްރައިވެސީ ޕޮލިސީ",
    cookies_title: "ކުކީ ޕޮލިސީ",
    terms_content: `
        <strong>1. ޝަރުތުތައް ބަލައިގަތުން</strong><br>
        އާގްވޮއިޑް އަށް ވަދެވުމުން، މި ޚިދުމަތުގެ ޝަރުތުތައް ބަލައިގަނެވޭނެއެވެ. މި ޝަރުތުތައް އެއްބަސް ނުވާނަމަ، އެ ހިދުމަތް ބޭނުން ނުކުރެވޭނެއެވެ.<br><br>

        <strong>2. ޕްލެޓްފޯމް ބޭނުންކުރުން</strong><br>
        އާގްވޮއިޑް އާއި އޭގެ އެޕްލިކޭޝަންތައް ފޯރުކޮށްދެނީ "އެހެން ހުރި ގޮތަށް" މައުލޫމާތާއި އުފެއްދުންތެރިކަމުގެ ބޭނުމުގަ އެވެ. އެ ހިދުމަތް ބޭނުންކުރަންވާނީ ހަމައެކަނި ޙަލާލު ބޭނުންތަކަށެވެ.<br><br>

        އެކްސް10އެކްސް3. މަނާ ސުލޫކު</strong><br>
        ސައިޓްގެ ވަލްނަރެބިލިޓީސް ބޭނުންކުރުމާއި، ސްޕޭމްކުރުމާއި، ނުވަތަ ހުއްދަ ނެތި އިންފްރާސްޓްރަކްޗަރަށް ވަނުމަށް މަސައްކަތްކުރުމަކީ ކަނޑައެޅިގެން މަނާކަމެކެވެ.<br><br>

        <strong>4 އެވެ. ޑިސްކްލޭމް</strong><br>
        އަދި އެންގުމަކާ ނުލައި ކޮންމެ ވަގުތެއްގައިވެސް ޕްލެޓްފޯމާއި ހިދުމަތްތަކަށް ބަދަލު ގެނެވިދާނެއެވެ. ޚިދުމަތް އަޕްޓައިމް ނުވަތަ ލިބޭނެ ގޮތާ ގުޅޭ އެއްވެސް ވޮރެންޓީއެއް ނުދެއެވެ.
    `,
    policy_content: `
        <strong>1. މަޢުލޫމާތު އެއްކުރުން</strong><br>
        މި ޕްލެޓްފޯމްގައި މިވަގުތު ޔޫޒަރ އޮތެންޓިކޭޝަން ނުވަތަ އެކައުންޓް ކްރިއޭޓް ކުރަން ނުޖެހެއެވެ. ޒިޔާރަތްކުރާ ފަރާތްތަކުގެ ފަރާތުން އެއްވެސް ޒާތީ މައުލޫމާތެއް (ނަން ނުވަތަ އީމެއިލް އެޑްރެސް ފަދަ) ހީވާގިކަމާއެކު އެއް ނުކުރެވެއެވެ.<br><br>

        <strong>2. ބޭނުންކުރުމުގެ ޑޭޓާ</strong><br>
        ސައިޓްގެ ޓްރެފިކް ދެނެގަނެ، އެޕްލިކޭޝަންތައް ރަނގަޅު ކުރުމަށްޓަކައި އަސާސީ، ނަން ނުޖެހޭ އެނަލިޓިކްސް އެއްކުރެވިދާނެ އެވެ. މި ޑޭޓާއަކީ ވަކިވަކި ޔޫޒަރ އައިޑެންޓިޓީތަކާ ގުޅިފައިވާ ޑޭޓާއެއް ނޫނެވެ.<br><br>

        އެކްސް10އެކްސް3. ތިންވަނަ ފަރާތެއްގެ ހިދުމަތްތައް</strong><br>
        ހޯސްޓިންގ އަދި އެނަލިޓިކްސް ޚިދުމަތްތަކަށް ތިންވަނަ ފަރާތެއްގެ ޕްރޮވައިޑަރުން ބޭނުންކުރެވިދާނެއެވެ. މި ޕްރޮވައިޑަރުންގެ ޕްރައިވެސީ ޕްރެކްޓިސްތަކުން އެމީހުންގެ އިންފްރާސްޓްރަކްޗަރގައި ޕްރޮސެސް ކުރެވޭ ނަން ނުޖެހޭ ޑޭޓާ ބެލެހެއްޓޭނެއެވެ.<br><br>

        <strong>4 އެވެ. ޑޭޓާ ސެކިއުރިޓީ</strong><br>
        އެ ޕްލެޓްފޯމް ހިމާޔަތް ކުރުމަށްޓަކައި އެކަށީގެންވާ ސަލާމަތީ ފިޔަވަޅުތައް އަޅަ އެވެ. ނަމަވެސް އިންޓަރނެޓް މެދުވެރިކޮށް ޓްރާންސްމިޓް ކުރުމުގެ އެއްވެސް ގޮތަކީ މުޅިން ރައްކާތެރި ގޮތެއް ނޫނެވެ.<br><br>
    `,
    cookies_content: `
        <strong>1. ކުކީސް އާއި ލޯކަލް ސްޓޯރޭޖަކީ ކޮބައިތޯ؟</strong><br>
        ކުކީސް އަދި ބްރައުޒާ ލޯކަލް ސްޓޯރޭޖަކީ ވިޒިޓްތަކުގެ ތެރެއިން ކޮންފިގްރޭޝަން ޕްރެފެރެންސްތައް ހަނދާން ބެހެއްޓުމަށްޓަކައި ޑިވައިސްގައި ރައްކާކުރެވޭ ކުދި ޑޭޓާ ފައިލްތަކެކެވެ.<br><br>

        <strong>2. ބޭނުންކުރުމުގެ މަޤްޞަދު</strong><br>
        ބްރައުޒާ ލޯކަލްސްޓޯރޭޖް ބޭނުންކުރަނީ ކޮންފިގްރޭޝަން ސެޓިންގްސް ސޭވް ކުރުމަށް ހަރުކަށިކޮށް، ފަދައިން:<br>
        - ބަހުގެ އިސްކަންދިނުން<br>
        - ޔޫޒަރ އިންޓަރފޭސް ކޮންފިގްރޭޝަން (އެބަހީ، ލޭއައުޓް ނުވަތަ ތީމް ސެޓިންގސް)<br>
        - ވަގުތީ އެޕްލިކޭޝަން cache<br><br>

        <strong>3 އެވެ. ޓްރެކިންގއެއް ނެތް</strong><br>
        ކުކީސް އާއި ލޯކަލް ސްޓޯރޭޖް އިޝްތިހާރު ކުރުމަށް ނުވަތަ ތިންވަނަ ފަރާތެއްގެ ޓްރެކިންގެ ބޭނުމުގައި ބޭނުން ނުކުރެއެވެ. ރައްކާކުރެވިފައިވާ ހުރިހާ ޑޭޓާއަކީވެސް ޕްލެޓްފޯމްގެ މައިގަނޑު ފަންކްޝަނަލިޓީއަށް ޚާއްޞަކޮށްފައިވާ ޑޭޓާއެކެވެ.<br><br>

        <strong>4 އެވެ. ކޮންޓްރޯލް</strong><br>
        ބްރައުޒާ ސެޓިންގްސް މެދުވެރިކޮށް ކޮންމެ ވަގުތަކުވެސް ބްރައުޒާ ޑޭޓާ ކްލިއަރ ކުރެވޭއިރު، މިއީ ކޮންމެ ލޯކަލް ކޮންފިގްރޭޝަނެއް ރީސެޓް ކުރާނެ ކަމެކެވެ.
    `,
    cookie_consent_text: "އަޅުގަނޑުމެން އަސާސީ ކުކީޒް ބޭނުންކުރަނީ ވެބްސައިޓް ރަނގަޅަށް މަސައްކަތްކުރާކަން ޔަގީންކުރުމަށް، ސެޝަން އެކްޓިވްކޮށް ބެހެއްޓުމާއި، ބަހުގެ އިސްކަންދޭ ސޭވްކުރުމާއި، އެހެނިހެން ކަސްޓަމް ކޮންފިގްރޭޝަންތައް.",
    read_policy: "ކުކީ ޕޮލިސީ ކިޔާށެވެ",
    support_title: "ސަޕޯޓާ ގުޅުން",
    support_subject_label: "މައުޝޫއު",
    support_message_label: "މެސެޖް",
    support_submit_button: "މެސެޖް ފޮނުވުން",
    support_hint: "ނޯޓް: މިއީ މެސެޖު ފޮނުވުމަށް ޑިފޯލްޓް އީމެއިލް އެޕްލިކޭޝަން ހުޅުވާލާނެ ކަމެކެވެ.",
    support_success_msg: "އީމެއިލް އެޕް ހުޅުވައިގެން...",
    support_error_msg: "މެސެޖް ފޮނުވަން ނާކާމިޔާބުވިއެވެ. ފަހުން އަނެއްކާވެސް މަސައްކަތް ކުރައްވާށެވެ.",
    explorer_title: "އެކްސްޕްލޯރަރ އެވެ",
    history_title: "ތާރީޚް",
    animation_title: "އެނިމޭޝަން",
    config_title: "ކޮންފިގްރޭޝަން",
    tool_mouse: "(Ctrl+M) ހޮވާށެވެ.",
    tool_brush: "ބުރުސް (Ctrl+B)",
    tool_brush_mode: "ޓޮގްލް މޯޑް (ސޮލިޑް/ކްލިއަރ)",
    tool_eraser: "އިރޭސަރ (Ctrl+E)",
    tool_brush_size: "ބްރަޝް ސައިޒް އެޖެސްޓްކުރުން",
    tool_bucket: "ފުރިހަމަކުރުން (Ctrl+F)",
    tool_eyedropper: "އައިޑްރޮޕަރ އެވެ",
    tool_grid: "ގްރިޑް (ސީޓީއާރުއެލް+ޝިފްޓް+ބީ)",
    tool_rotate: "އެނބުރުވުން (Ctrl+Shift+R)",
    tool_flip_h: "ފްލިޕް އެޗް (ސީޓީއާރުއެލް+ޝިފްޓް+އެޗް)",
    tool_flip_v: "ފްލިޕް ވީ (ސީޓީއާރުއެލް+ޝިފްޓް+ވީ)",
    tool_transpose: "ޓްރާންސްޕޯސް (Ctrl+Shift+T) .",
    label_width: "ފުޅާމިން",
    label_height: "އުސްމިން",
    label_frames: "ފްރޭމްތަކުގެ އަދަދު",
    label_animation: "އެނިމޭޝަން ސްޓައިލް",
    label_background_color: "ބެކްގްރައުންޑް ކުލަ",
    label_interval: "އިންޓަވަލް",
    tool_anim_config: "އެނިމޭޝަން ކޮންފިގްރޭޝަން",
    label_new_width: "އައު ފުޅާމިން",
    label_new_height: "ނިއު ހައިޓް އެވެ",
    label_apply: "އެޕްލައި",
    label_colors: "ކުލަތަކެވެ",
    label_size: "ސައިޒް",
    label_tolerance: "ކެތްތެރިކަން",
    val_horizontal: "ދިގަށް",
    val_vertical: "ދިގަށް",
    val_sequence: "ސީކުއެންސް",
    val_bounce: "ބައުންސް",
    val_random: "ވަކޮގޮތެއްނެތް",
    val_solid: "ސޮލިޑް",
    val_clear: "ސާފުކޮށް",
    action_add_sheet: "ނިއު ޝީޓް",
    action_import: "އެތެރެކުރުން",
    action_export: "އެކްސްޕޯޓް",
    action_sort_projects: "ހަމައަކަށް އެޅުވުން",
    sort_date_old: "އެންމެ ދުވަސްވީ ފުރަތަމަ",
    sort_date_new: "އެންމެ އަލަށް ފުރަތަމަ",
    sort_name_az: "ނަން (އޭ-ޒެޑް)",
    sort_name_za: "ނަން (ޒެޑް-އޭ)",
    action_new_sprite: "ނިއު ސްޕްރައިޓް އެވެ",
    action_new_project: "އާ މަޝްރޫއެއް",
    modal_save_all_title: "ހުރިހާ ބަދަލެއް ސޭވްކުރުން",
    modal_save_all_desc: "ސޭވް ކުރަން ބޭނުންވާ އެސެޓްތައް ހޮވުން:",
    modal_save_selected: "ސޭވް ސެލެކްޓް ކޮށްފައި",
    action_saved: "ރައްކާކުރެވިއްޖެއެވެ",
    modal_create_sprite_title: "ނިއު ސްޕްރައިޓް އުފެއްދުން",
    modal_create_project_title: "އާ ޕްރޮޖެކްޓެއް އުފެއްދުން",
    modal_add_sheet_title: "އާ ޝީޓް އިތުރުކުރުން",
    modal_rename_sheet_title: "ޝީޓްގެ ނަން ބަދަލުކުރުން",
    modal_rename_sprite_title: "ސްޕްރައިޓް އަށް ނަން ބަދަލުކޮށްލާށެވެ",
    modal_delete_sprite_title: "ސްޕްރައިޓް ޑިލީޓް ކުރުން",
    modal_delete_project_title: "ޕްރޮޖެކްޓް ޑިލީޓްކުރުން",
    modal_delete_sheet_title: "ޑިލީޓް ޝީޓް",
    placeholder_sprite_name: "ނަން",
    placeholder_project_name: "ނަން",
    placeholder_sheet_name: "ނަން",
    placeholder_new_name: "އާ ނަމެއް",
    action_create: "ތައްޔާރުކުރުން",
    action_add: "އެއްކުރުން",
    action_rename: "ނަން ބަދަލުކޮށްލާށެވެ",
    action_duplicate: "ޑަބިލިކޭޓް ކުރުން",
    action_delete: "ޑިލީޓް",
    action_cancel: "ކެންސަލް",
    confirm_delete_sprite: "މި ސްޕްރައިޓް ޑިލީޓް ކުރަން ބޭނުންވާކަން ޔަގީން ހެއްޔެވެ؟",
    confirm_delete_project: "މި ޕްރޮޖެކްޓް ޑިލީޓް ކުރަން ބޭނުންވާކަން ޔަގީން ހެއްޔެވެ؟ ހުރިހާ ސްޕްރައިޓްތަކެއް ނައްތާލެވޭނެއެވެ.",
    confirm_delete_sheet: "މި ޝީޓް ޑިލީޓް ކުރަން ބޭނުންވާކަން ޔަގީން ހެއްޔެވެ؟",
    err_select_sprite: "ފުރަތަމަ ސްޕްރައިޓެއް ހޮވާށެވެ.",
    err_select_project: "ފުރަތަމަ ޕްރޮޖެކްޓެއް ހޮވާށެވެ.",
    err_name_empty: "ނަން ހުސްނުވެވޭނެއެވެ.",
    err_sprite_exists: "އެ ނަމުގައި ސްޕްރައިޓެއް މިހާރުވެސް އެބަހުއްޓެވެ.",
    err_project_exists: "އެ ނަމުގައި ޕްރޮޖެކްޓެއް މިހާރުވެސް އެބައޮތެވެ.",
    err_no_content: "ސޭވް ކުރަން ކޮންޓެންޓެއް ނެތެވެ.",
    err_no_changes: "ސޭވް ކުރަން އެއްވެސް ބަދަލެއް ނެތެވެ.",
    err_delete_last_sheet: "އެންމެ ފަހު ޝީޓް ޑިލީޓް ނުކުރެވޭނެއެވެ.",
    err_extract_frames: "އެއްވެސް ފްރޭމެއް ނެގިފައެއް ނުވެއެވެ.",
    err_indexeddb: "ލޯކަލް ގޮތުން ސޭވް ނުކުރެވުނެވެ. ތިބާގެ ބްރައުޒާ އިންޑެކްސްޑްޑީބީ އަށް ސަޕޯޓް ނުކުރެވިދާނެއެވެ.",
    msg_upload_success: "އަޕްލޯޑް ކާމިޔާބު: {0}",
    msg_upload_failed: "އަޕްލޯޑް ނާކާމިޔާބު: {0}",
    msg_save_success: "ސަލާމަތްކުރުން ކާމިޔާބު.",
    msg_saving: "ސޭވިންގ...",
    msg_multi_save_result: "ސޭވްކޮށްފައިވާ {0} އެސެޓްތައް. {1} ނާކާމިޔާބީތަކެވެ.",
    menu_title: "މެނޫ",
    menu_save: "ރައްކާކުރުން",
    menu_save_all: "ސޭވް އޮލް",
    menu_support: "ސަޕޯޓާ ގުޅުން",
    label_local_storage: "ލޯކަލް ސްޓޯރޭޖް",
    label_sign_in: "ސައިން އިން",
    modal_export_title: "އެކްސްޕޯޓް ސްޕްރައިޓް",
    label_filename: "ފައިލް ނަން",
    label_format: "ފޯމެޓް",
    action_export_confirm: "އެކްސްޕޯޓް",
};

export default translations;
